import { render, staticRenderFns } from "./MoreProductBanner.vue?vue&type=template&id=0816837c&scoped=true&"
import script from "./MoreProductBanner.vue?vue&type=script&lang=js&"
export * from "./MoreProductBanner.vue?vue&type=script&lang=js&"
import style0 from "./MoreProductBanner.vue?vue&type=style&index=0&id=0816837c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0816837c",
  null
  
)

export default component.exports